import React from 'react'

const ModalChoiceStaffUsers = ({ staff, _choiceStaff, valuesService, services }) => {
    return (
        <div className="modal fade" id="modalChoiceStaffUsers" >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="modalChoiceStaffUsers"></h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div 
                            data-bs-dismiss="modal" 
                            aria-label="Close" 
                            style={{cursor:'pointer'}}
                            onClick={() => _choiceStaff('','','')}
                        >Sans préférences</div>
                        {services.filter(s => s.id === valuesService.idService).map(s => (
                            <div key={s.id}>
                                {staff.map(st => (
                                    <div
                                        key={st.id} 
                                        data-bs-dismiss="modal" 
                                        aria-label="Close" 
                                        style={{cursor:'pointer'}}
                                        className='mt-3'
                                        onClick={() => _choiceStaff(st.id, st.surnameStaff, st.nameStaff)}
                                    >
                                        {s[st.id] === true && st.surnameStaff}
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalChoiceStaffUsers


